export const TRACKING_MODES = {
  PROGRESS: 'Progress',
  CHECKLIST: 'Checklist',
  RAG: 'RAG',
  NONE: 'None',
};

export const TRACKING_MODE_OPTIONS = [
  { value: TRACKING_MODES.PROGRESS, label: 'Progress (0-100%)' },
  { value: TRACKING_MODES.CHECKLIST, label: 'Checklist' },
  { value: TRACKING_MODES.RAG, label: 'RAG Status' },
  { value: TRACKING_MODES.NONE, label: 'None' },
];

export const getTrackingModeLabel = (mode) => {
  const option = TRACKING_MODE_OPTIONS.find(opt => opt.value === mode);
  return option?.label || mode;
};
